import { supabase } from './supabase';
import { localDateStr } from './date';

// Cek apakah hari ini termasuk dalam rentang libur toko yang aktif.
// Return null kalau tidak libur, atau { id, date_from, date_to, reason, reopen_note } kalau libur.
export async function getActiveHoliday() {
  const today = localDateStr();
  const { data } = await supabase
    .from('store_holidays')
    .select('*')
    .eq('is_active', true)
    .lte('date_from', today)
    .gte('date_to', today)
    .order('date_from', { ascending: true })
    .limit(1)
    .maybeSingle();
  return data || null;
}

// Format tanggal Indonesia yang ramah untuk pesan libur, mis. "Senin, 4 Agustus 2026"
export function fmtHolidayDate(d) {
  return new Date(d).toLocaleDateString('id-ID', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
}

// Pesan ramah kapan toko buka lagi, dipakai di layar "Sedang Libur"
export function buildReopenMessage(holiday) {
  if (!holiday) return '';
  if (holiday.reopen_note?.trim()) return holiday.reopen_note.trim();
  const reopenDate = new Date(holiday.date_to);
  reopenDate.setDate(reopenDate.getDate() + 1);
  return `Kami buka lagi mulai ${fmtHolidayDate(reopenDate)}.`;
}
